
import axios from "axios";
import api_url from "../api_url";


const API_URL = `${api_url}/api/first_section`;

const getAllHeroSections = async () => {
    const response = await axios.get(API_URL);
    return response.data;
};

const createHeroSection = async (data, token) => {
    const response = await axios.post(API_URL, data, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

const updateHeroSection = async (id, data, token) => {
    const response = await axios.put(`${API_URL}/${id}`, data, {
        headers: { Authorization: `Bearer ${token}` },
    });
    return response.data;
};

export { getAllHeroSections, createHeroSection, updateHeroSection };
